<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Xtg2it/tc-custom/9780226432212.jpg?1737195128677" alt="This image is the cover for the book Regulation vs. Litigation, National Bureau of Economic Research Conference Report"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Regulation vs. Litigation, National Bureau of Economic Research Conference Report
      </h1>
      <p class="bookDescription body article font2">
        <p> The efficacy of various political institutions is the subject of intense debate between proponents of broad legislative standards enforced through litigation and those who prefer regulation by administrative agencies. This book explores the trade-offs between litigation and regulation, the circumstances in which one approach may outperform the other, and the principles that affect the choice between addressing particular economic activities with one system or the other. Combining theoretical analysis with empirical investigation in a range of industries, including public health, financial markets, medical care, and workplace safety, <i>Regulation versus Litigation</i> sheds light on the costs and benefits of two important instruments of economic policy.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel P. Kessler
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Daniel P. Kessler</B> is a professor at the Law School and Graduate School of Business, Stanford University; a senior fellow at Stanford's Hoover Institution; and a research associate of the NBER.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66de641e